import { EmployeeLiteModel } from 'api-hooks/employee';
import { PurchaseModel } from 'api-hooks/order/common/model';
import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class ProductVariantModel {
  description: string;
  id: string;
  name: string;
  stock: number;

  @Expose({ name: 'average_price' })
  averagePrice: string;

  @Expose({ name: 'sell_price' })
  sellPrice: string;
}

export class ProductModel {
  code: string;
  description: string;
  id: string;
  name: string;
  stock: any;
  variant: any;

  @Expose({ name: 'total_stock_value' })
  totalStockValue: string;
}

export class ProductPurchaseItemModel {
  id: string;
  description: string;

  @Type(() => Number)
  price: number;

  @Type(() => Number)
  qty: number;

  @Expose({ name: 'complete_name' })
  completeName: string;

  @Type(() => ProductModel)
  product: ProductModel;

  @Expose({ name: 'product_variant' })
  @Type(() => ProductVariantModel)
  productVariant: ProductVariantModel;
}

export class ProductPurchaseOtherFeesModel extends CommonModel {
  name: string;
  description?: string;

  @Type(() => Number)
  price: number;
}

export class ProductPurchaseModel extends PurchaseModel {
  @Expose({ name: 'product_purchases' })
  @Type(() => ProductPurchaseItemModel)
  productPurchases: ProductPurchaseItemModel[];

  @Expose({ name: 'product_purchase_other_fees' })
  @Type(() => ProductPurchaseOtherFeesModel)
  productPurchaseOtherFees: ProductPurchaseOtherFeesModel[];

  @Expose({ name: 'tour_id' })
  tourId: string;
}

export class ProductPurchaseLiteModel extends CommonModel {
  agent: string;
  code: string;
  description: string;
  number: string;

  @Expose({ name: 'payment_channel' })
  paymentChannel: string;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

//query
export type getProductsPurchaseInput = {
  params: CommonParamInput;
};

export type getProductPurchaseInput = {
  id: string;
};

//mutation
export type ProductPurchaseMutationInput = {
  refId?: string;
  code: string;
  description: string;
  transactionAt: Date;
  needApproval: boolean;
  agentId: string;
  paymentChannelId: string;
  discount: number;
  otherCost: number;
  total: number;
  commission: number;

  productPurchases: {
    productVariantId: string;
    price: number;
    qty: number;
    description: string;
  }[];

  productPurchaseOtherFees: {
    name: string;
    price: number;
    description: string;
  }[];
};

export type ProductPurchaseMutationUpdateInput = {
  id: string;
  body: ProductPurchaseMutationInput;
};

export type ProductPurchaseMutationVoidInput = {
  id: string;
};
